module.exports = __webpack_public_path__ + "img/DE00313.222e5d3b.png";